export const ROLES_LIST_REQUESTING = 'roles/ROLES_LIST_REQUESTING';
export const ROLES_LIST_SUCCESS = 'roles/ROLES_LIST_SUCCESS';
export const ROLES_LIST_FAILED = 'roles/ROLES_LIST_FAILED';
